import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Do NOT have any imports as this will be imported into 'Production' code - it essentially decouples
// Test-related state from the actual test classes (and thus is safe for production code to include)

/**
 * Test Setup methods useful to all modules.
 * If the Test Utility method is specific to abweb module's karma tests (not for use by downstream modules),
 * it should be put in the module's TestModHelper class (which isn't accessible to downstream modules).
 */
export class TestState {
  constructor() {
    // static class, can't create an instance
  }
  static get TEST_MODE() {
    return TestState._TEST_MODE;
  }

  // Only JasmineConfiguration should ever call this method (package protected via 'any' hack)
  // @ts-ignore: noUnusedLocals
  static setTestMode(val) {
    TestState._TEST_MODE = val;
  }
  static readTestCookie(name) {
    const value = TestState.TestCookies[name];
    if (value !== undefined) {
      // null is valid, undefined is not
      return value;
    }
    // Defensive: see comments in UserLocalePreferenceXSpec.ts for details.
    // Should either add the cookie to the 'default' TestCookies map, or mock the readCookie invocation within test
    throw new Error("Karma does not support reading cookies, so can't read cookie '" + name + "'.");
  }
  static writeTestCookie(name, value) {
    TestState.TestCookies[name] = value;
  }
  static deleteTestCookie(name) {
    TestState.TestCookies[name] = null;
  }
}
_defineProperty(TestState, "_TEST_MODE", false);
// During karma tests, javascript can not read the cookie values (document.cookie is always an empty string)
// For widely used cookies, have default values (so that every test doesn't need to mock URLUtils.readCookie)
_defineProperty(TestState, "TestCookies", {
  "csrfToken": null,
  "ai_locale": "en",
  "ai_locale_preferred": "en",
  "X-AbInitio-Response": "true"
});
//# sourceMappingURL=TestState.js.map
